import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Textfield from "@atlaskit/textfield";
import { ErrorMessage } from "@atlaskit/form";
import { Box } from "@atlaskit/primitives";
import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";
import ServerTime from "../../../integrations/flow/edit/trigger/ServerTime";
import { setCurrentWizardData } from "../../../redux/actions/wizardActions";

const WizardSchedule = () => {
  const [value, setValue] = useState("0 9 * * *");
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationError, setValidationError] = useState("");
  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);

  const flow = useSelector((state) => state.integration.flow);

  useEffect(() => {
    if (currentData && currentData.cron) {
      setValue(currentData.cron);
    }
  }, [currentData]);

  const changeValue = (e) => {
    setValue(e.target.value);
    updateRedux(e.target.value);
  };
  const setValueFromEditor = (_value) => {
    setValue(_value);
    //block changing the edit to dirty if no change has happen
    if (currentData && currentData.cron !== _value) {
      updateRedux(_value);
    }
  };
  const updateRedux = (_value) => {
    const updatedData = {
      ...currentData,
      cron: _value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };
  const displayError = (err) => {
    if (err) {
      setShowValidationError(true);
      setValidationError(err.description);
    } else {
      setShowValidationError(false);
      setValidationError("");
    }
  };

  return (
    <div className="ihub-edit-trigger">
      <p>
        Choose when and how often you want this 'Flow' to happen using a 'cron' schedule. Our internal scheduler checks for tasks every 10 minutes. This
        means if you set a cron job for a specific time, it will run within 10 minutes of that time, not exactly at the minute you set.
      </p>
      <h5>Enter Unix formatted cron</h5>
      <Textfield name="aws-cron" value={value} isCompact onChange={changeValue} />
      {showValidationError && (
        <ErrorMessage>
          <Box as="span">{validationError}</Box>
        </ErrorMessage>
      )}
      <Cron value={value ? value : ""} setValue={setValueFromEditor} onError={displayError} />
      Cron is running on UTC time, current date time is <ServerTime />
    </div>
  );
};
export default WizardSchedule;
